import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useAuth } from '../../../../data/hooks/auth'

type HeaderMenuProps = {
  isOpen: boolean
  close: () => void
}

const HeaderMenu: React.FunctionComponent<HeaderMenuProps> = ({ isOpen, close }) => {
    const { pathname } = useLocation()

    const { user, setAuth } = useAuth()
    const { t } = useTranslation("common")

    return (
        <Menu isOpen={isOpen}>
            <Entry to={`/feed`} onClick={close} current={pathname === '/feed'}>
                <MenuIcon src={require(`./images/home${pathname === '/feed' ? '_active' : ''}.svg`)} />
                <EntryText>{t("header.home")}</EntryText>
            </Entry>
            { user && 
            <Entry to={`/profile/${user?.public_id}`} onClick={close} current={pathname.startsWith('/profile')}>
                <MenuIcon src={require(`./images/profile${pathname.startsWith('/profile') ? '_active' : ''}.svg`)} />
                <EntryText>{t("header.profile")}</EntryText>
            </Entry>
            }
            { user && 
            <Entry to='/library' onClick={close} current={pathname === '/library'}>
                <MenuIcon src={require(`./images/library${pathname === '/library' ? '_active' : ''}.svg`)} />
                <EntryText>{t("header.library")}</EntryText>
            </Entry>
            }
            <Entry to={`/trending`} onClick={close} current={pathname === '/trending'}>
                <MenuIcon src={require(`./images/trending${pathname === '/trending' ? '_active' : ''}.svg`)} />
                <EntryText>{t("header.trending")}</EntryText>
            </Entry>
            <Entry to='/faq' target='blank'>
                <MenuIcon src={require('./images/faq.svg')} />
                <EntryText>{t("header.faq")}</EntryText>
            </Entry>
            { user && 
            <Entry to='' onClick={() => {
                setAuth(null, null)
                close()
            }} burgerOnly>
                <MenuIcon src={require('./images/logout.svg')} />
                <EntryText>{t("header.logout")}</EntryText>
            </Entry>
            }
        </Menu>
    )
}



const Menu = styled.div<{isOpen: boolean}>`
    display: ${p => p.isOpen ? 'flex' : 'none'};

    position: absolute;
    top: 100%;
    left: 0;
    flex-direction: column;
    justify-self: center;

    height: 100vh;
    width: 100%;
    background: ${p => p.theme.colors.bgService};
    padding: 54px 18px;

    z-index: 100;

    ${up('desktop')} {
        display: flex;
        position: relative;
        top: auto;
        left: auto;

        flex-direction: row;
        align-items: center;

        width: auto;
        height: auto;

        background: none;
        padding: 0;

        margin-left: 50px;
    }
`

const MenuIcon = styled.img<{ visible?: boolean }>`
    width: 24px;
    height: 24px;

    margin-right: 18px;

    ${up('desktop')} {
        margin-right: 0px;
    }
`

const Entry = styled(Link)<{ burgerOnly?: boolean, current?: boolean}>`
    position: relative;

    display: flex;
    align-items: center;
    grid-template-rows: auto;

    margin-right: 40px;
    margin-bottom: 48px;
    font-size: 15px;
    line-height: 28px;
    font-weight: ${p => p.current ? 'bold' : 'normal'};

    &, &:visited, &:hover {
        text-decoration: none;
        color: ${p => p.theme.colors.hushed};
    }

    ${up('desktop')} {
        display: ${ p => p.burgerOnly ? 'none' : 'flex'};
        margin-bottom: 0;
    }

    ${up('desktop')} {
        &:after {
            position: absolute;
            bottom: -10px;
            left: -10px;
            right: 0;

            width: calc(100% + 20px);
            height: 3px;
            background: ${p => p.current ? p.theme.colors.accent : 'transparent'};

            content: "";
        }
    }

    &:hover {
        ${ p => !p.current ? 'filter: brightness(0) saturate(100%) invert(37%) sepia(44%) saturate(1904%) hue-rotate(219deg) brightness(89%) contrast(88%);' : '' }
    }
`

const EntryText = styled.span`
    ${up('desktop')} {
        display: none;
    }
`

export default HeaderMenu